/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from "react";

import styles from "./CustomProductOptionBrandRefresh.module.css";

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M18.75 5.25L5.25 18.75" stroke="#3B0055" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.75 18.75L5.25 5.25" stroke="#3B0055" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const BrandRefreshDescriptionModal = ({ title, description, onClose }) => {
  useEffect(() => {
    const onKeyDown = e => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <div
      className={styles.modalBackdrop}
      data-part="product-description-modal"
      role="button"
      tabIndex={-1}
      aria-label="Close description"
      onClick={onClose}
    >
      <div
        className={styles.modalContent}
        role="presentation"
        onClick={e => e.stopPropagation()}
      >
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>{title}</h3>
          <button
            type="button"
            className={styles.modalClose}
            aria-label="Close description"
            data-part="close-description"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>
        <div className={styles.modalBody}>
          <p data-part="product-description">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default BrandRefreshDescriptionModal;